/**
 * @file settingLabels.js
 * @description Display labels for the canonical work-setting values stored on
 *   cases and profiles (Home, School, Clinic, Community, Remote). The stored
 *   value never changes; only the label shown to people is translated.
 * @module lib/settingLabels
 */
const SETTING_LABEL_KEYS = {
  Home:      "case.settingHome",
  School:    "case.settingSchool",
  Clinic:    "case.settingClinic",
  Community: "case.settingCommunity",
  Remote:    "case.settingRemote",
};

/** Translated label for a setting value; unknown values pass through unchanged. */
export function settingLabel(t, value) {
  const key = SETTING_LABEL_KEYS[value];
  return key ? t(key) : value;
}

/** Canonical work settings, in display order (case and provider filters). Legacy lower-case values collapse onto these. */
export const WORK_SETTINGS = Object.freeze(["Home", "School", "Clinic", "Community", "Remote"]);

/** Canonical employment types: W2 = employee, 1099 = contractor. full_time/part_time are commitment, not type. */
export const EMPLOYMENT_TYPES = Object.freeze(["W2", "1099"]);
